import script from "./ObrasSolicitacaoViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ObrasSolicitacaoViewPage.vue?vue&type=script&setup=true&lang=js"

import "./ObrasSolicitacaoViewPage.vue?vue&type=style&index=0&id=6d117c01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d117c01"]])

export default __exports__